import { MODALS_ENUM } from "@constants/Modals";
import styles from "./AssignNotificationGroup.module.scss";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { Select } from "@components/global/new/Select/Select";
import { Button } from "antd";

type AssignNotificationGroupProps = CommonModalPropsI & {
  groupName: string;
};

function AssignNotificationGroup(props: AssignNotificationGroupProps) {
  return <div className={styles.wrapper}>
    <h4 className={styles.title}>
      <span>{props.formatMessage({ id: "modal.assignNotificationGroup.title.assign" })}</span>
      <span> {props.groupName} </span>
      <span>{props.formatMessage({ id: "modal.assignNotificationGroup.title.to" })}</span>
    </h4>
    <Select
      label={<span className={styles.label}>
        {props.formatMessage({ id: "modal.assignNotificationGroup.selectGroup" })}
      </span>}
    />
    <div className={styles.buttons}>
      <Button type="primary" onClick={props.handleClose}>{props.formatMessage({ id: "modal.assignNotificationGroup.buttons.assign" })}</Button>
      <Button onClick={props.handleClose}>{props.formatMessage({ id: "modal.assignNotificationGroup.buttons.cancel" })}</Button>
    </div>
  </div>
}

export default WithModal(MODALS_ENUM.ASSIGN_NOTIFICATION_GROUP, AssignNotificationGroup);
